import React from 'react';
import Datetime from 'react-datetime';
import { getImgSrc } from '../helpers/getImgSrc';
import "./date-picker.css"

// Date Picker Field Component
const DatePickerField = ({ selected, onChange,placeholder}) => (
        <div className="position-relative">
            <Datetime
                value={selected}
                placeholder={placeholder}
                onChange={onChange}
                dateFormat="DD-MM-YYYY" // Adjusted to your desired format
                timeFormat={false} // Disable time selection if you don't need it
                inputProps={{ placeholder: placeholder }}
                closeOnClickOutside
                closeOnSelect
            />
            <div className="calender_icon">
                <img src={getImgSrc('calender', 'svg')} alt="Calendar Icon" />
            </div>   
    </div>
);

export default DatePickerField;
